// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__d2hzA","rightAdornment":"Header_rightAdornment__1-KnN"};